/**
 * Valida se o email possui formato válido
 */
export const isValidEmail = (email: string): boolean => {
  // Validação mais completa e alinhada com o backend
  // Permite extensões de domínio mais longas como .info, .online, etc.
  const emailRegex = /^[a-zA-Z0-9][\w.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

/**
 * Valida se o nome está preenchido corretamente
 */
export const isValidName = (name: string): boolean => {
  return name.trim().length >= 3;
};

/**
 * Valida se o documento não está vazio e respeita os limites de caracteres
 * Aceita diferentes tipos de documentos (CPF, RG, passaportes, etc.)
 */
export const isValidDocument = (document: string): boolean => {
  // Remove caracteres especiais para contagem
  const cleanDocument = document.replace(/[.\-\s/]/g, '');
  
  // Verifica se o documento tem pelo menos 3 caracteres e no máximo 20
  return cleanDocument.length >= 3 && cleanDocument.length <= 20;
};

/**
 * Valida o formulário completo
 */
export const validateForm = (name: string, email: string, document: string): { isValid: boolean; errors: Record<string, string> } => {
  const errors: Record<string, string> = {};

  if (!isValidName(name)) {
    errors.name = 'O nome deve ter pelo menos 3 caracteres';
  }

  if (!isValidEmail(email)) {
    errors.email = 'Email inválido';
  }

  if (!isValidDocument(document)) {
    errors.document = 'Documento inválido. Deve ter entre 3 e 20 caracteres';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
}; 